import {ALL_PLATFORMS, AppPlatform, AppVersions, PLATFORM_DISPLAY_NAMES} from '../types/feedback';

/**
 * Versions en production, plateforme par plateforme.
 *
 * La valeur relevée sur les stores prime sur celle enregistrée dans
 * `config/app_versions` : c'est la plus à jour, et `useAppVersions` réécrit
 * ensuite le document avec elle. Passer `storeVersions` vide donne donc l'état
 * enregistré — c'est ce que veut une page qui décrit un filtre appliqué côté
 * serveur, lequel ne lit que le document.
 */
export function prodVersionLabels(
    versions: AppVersions | null,
    storeVersions: Record<string, string> = {},
): string[] {
    return ALL_PLATFORMS
        .map((platform) => ({platform, version: storeVersions[platform] || versions?.[platform]}))
        .filter((entry): entry is {platform: AppPlatform; version: string} => Boolean(entry.version))
        .map(({platform, version}) => `${PLATFORM_DISPLAY_NAMES[platform]} ${version}`);
}

/**
 * Liste de versions dont chaque couple plateforme/version reste insécable :
 * une version coupée en deux (« Web 2026- / 07-30 ») se lit mal et se recopie
 * mal. Le retour à la ligne n'a lieu qu'entre deux couples.
 */
export function VersionList({labels}: {labels: string[]}) {
    return (
        <>
            {labels.map((label, i) => (
                <span key={label} className="whitespace-nowrap">
                    {label}{i < labels.length - 1 ? ', ' : ''}
                </span>
            ))}
        </>
    );
}
